import { useCallback } from "react";

export function debounce<T extends Function>(func: T, timeout = 100): any {
    let timer: NodeJS.Timeout;
    return function (...args: any[]) {
        clearTimeout(timer);

        timer = setTimeout(() => {
            func(...args);
        }, timeout);
    };
}

export function useCallbackDebounce<T extends Function>(
    func: T,
    deps: React.DependencyList,
    timeout = 100
): T {
    return useCallback(debounce(func, timeout), deps);
}

